<div
  class="flex h-16 w-16 cursor-pointer flex-col items-center justify-center gap-0.5 rounded border-2 border-solid border-slate-100 bg-slate-50 p-1 text-slate-400"
  [ngClass]="{ 'hover:border-slate-500 hover:text-slate-500': hoverEnabled }"
>
  <mat-icon>{{ elementType | map: getIcon }}</mat-icon>
  <div class="text-xs font-bold">{{ elementType | titlecase }}</div>
</div>
